export enum AppEvent {
  API_MUTATION_ERROR = 'API_MUTATION_ERROR',
  API_FETCH_ERROR = 'API_FETCH_ERROR',
  OUTDATED_TOKEN = 'OUTDATED_TOKEN',
}
